// extracted by mini-css-extract-plugin
module.exports = {"thanksForRating":"ThanksForRating_thanksForRating__sC3QN","title":"ThanksForRating_title__13ire","description":"ThanksForRating_description__3r63y"};